import {useState} from "react";
import styled from "styled-components";
import Picker from "emoji-picker-react";
import { SearchContainer, SearchInput } from './ContactListComponent';
import { messageList } from "../mockData";


const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 3;
  background: #f6f7f8;
  `;

  const ProfileHeader = styled.div`
    display: flex;
    flex-direction: row;
    background: #ebeded;
    padding: 10px;
    align-items: center;
    gap: 10px;
  `;

  const ProfileImage = styled.img`
    width: 35px;
    height: 35px;
    border-radius: 50%
  `;

  // const ContactItem = styled.div`
  // display: flex;
  // flex-direction: row;
  // border-bottom: 1px solid #f2f2f2;
  // background: white;
  // cursor: pointer;
  // padding: 15px 12px
  // `;

  const ChatBox =styled.div `
  display: flex;
  background: #f0f0f0;
    padding: 10px;
    align-items: center;
    bottom: 0;
  `;

  const EmojiImage =styled.img`
  width: 28px;
  height: 28px;
  opacity: 0.4;
  cursor: pointer;
  `;


   // overflow-y will make the scrolling inside the precise container
  const MessageContainer =styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #e5ddd6;
  overflow-y: auto;
  `;

  // justify content flex-start here is used to push message to right end. props.isYours is to specify the message to move to flex start or end position depending on true or false value.

  const MessageDiv = styled.div`
  display: flex;
  justify-content: ${(props) => (props.isYours?"flex-end" : "flex-start")};
  margin: 5px 15px;
  `;


  // props here means if its your message to change background color
  const Message = styled.div`
  background: ${(props) => (props.isYours?"#daf8cb" : "white")};
  max-width: 50%;
  color: #303030;
  padding: 8px 10px;
  font-size: 14px;
  border-radius: 4px;
  `;

 
// here we create a funtion for the component 
const ConversationComponent = (props) => {
  const {selectedChat} = props;
  const [text, setText] = useState("");
  const [pickerVisible, togglePicker] = useState(false);


  const onEmojiClick = (event , emojiObj) => {
   setText(text + emojiObj.emoji);
  };

  return(
   <Container>
    <ProfileHeader>
    <ProfileImage src={selectedChat.profilePic} />
     {selectedChat.name}
    </ProfileHeader>
    <MessageContainer>
        {messageList.map((messageData) => (
        <MessageDiv isYours={messageData.senderID === 0}>
      <Message isYours={messageData.senderID === 0}>
      {messageData.text}
      </Message>
     </MessageDiv> 
     ))}
    </MessageContainer>

     <ChatBox>
    <SearchContainer>
    {pickerVisible && (
            <Picker
              pickerStyle={{ position: "absolute", bottom: "60px" }}
              onEmojiClick={(e, emoji) => {
                setText(text + emoji.emoji);
                togglePicker(false);
              }}
          />
        )}
    <EmojiImage 
    src={"/data.svg"}
    onClick={() => togglePicker ((pickerVisible) => !pickerVisible)} 
    
    />
      <SearchInput placeholder="Type message" value={text} onChange={(e)=>setText(e.target.value)}
      />
    </SearchContainer>
     </ChatBox>
   </Container>
   );
}


export default ConversationComponent;